import React from 'react';
import {Store as StoreIcon} from 'lucide-react';
import {AppTitle} from '../../../../Presentation/components/ui/Typography';

export const StoresPageHeader: React.FC = () => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <AppTitle>إدارة المتاجر</AppTitle>
        <p className="text-gray-600 mt-1">إدارة المتاجر وتتبع حالات الدفع والمخزون</p>
      </div>
      <div className="flex items-center text-sm text-gray-500">
        <StoreIcon className="w-4 h-4 mr-1" />
        نظام إدارة المتاجر المتكامل
      </div>
    </div>
  );
};
